import ChatPage from './features/chat/pages/ChatPage';
import type { AppRoute } from '@room/shared-ui';

export const routes: AppRoute[] = [
  { path: '/', component: ChatPage },
];
